export default __webpack_public_path__ + "74b469cdba84097c1e966beeb1d4fa42.svg";